import { types } from './mutation-types'
import DefaultState from './default_state.js'
export const mutations = {
  [types.SHOW_POPUP](state, item) {
    state.popupOn = true;
  },

  [types.SHOW_DELETE_PROJECT_POPUP](state, item) {
    state.popupDeleteProject = item;
  },

  [types.CLEAR_PROJECT_STATE](state, item) {
    state.currentProjectName = "";
    state.currentProjectRate = 0;
    state.currentProjectCost = 0;
    state.currentProjectModules = 0;
    state.currentProjectModuleColumns = 0;
    state.currentProjectContingency = 0;
    state.currentProjectOverrides = [];
    state.currentProjectPhases = [];
    state.currentProjectComments = [];
    state.showCalculator = false;
    state.showPricesComments = false;
    state.showPricesHours = false;
    state.showPricesPrices = false;
  },

  [types.AUTH_ERROR](state, item) {
    if (item === "auth/user-not-found" || item === "auth/wrong-password") {
      state.authError = "Incorrect e-mail or password.";
    } else if (item === "auth/invalid-email") {
      state.authError = "Invalid e-mail format.";
    } else if (item === "auth/weak-password") {
      state.authError = "Password must be at least 8 characters.";
    } else if (item === "auth/email-already-in-use") {
      state.authError = "This e-mail is taken.";
    }
  },
  [types.POPUP_EXPORT_PROJECT_DATA](state, item) {
    state.popupExportProjectData = item;
  },
  [types.POPUP_TOO_MANY_PROJECTS](state, item) {
    state.popupTooManyProjects = true;
  },
  [types.POPUP_TOO_MANY_PROJECTS_HIDE](state, item) {
    state.popupTooManyProjects = false;
  },
  [types.SET_AUTH_ERROR](state, item) {
    state.authError = item.message;
  },
  [types.CLEAR_AUTH_ERROR](state, item) {
    state.authError = null;
    state.afterEmailRecovery = null;
  },

  [types.POPUP_PROJECT](state, item) {
    state.popupProject = item;
  },

  [types.HIDE_POPUP](state, item) {
    state.popupOn = false;
  },

  [types.TOGGLE_CALCULATOR](state, item) {
    state.showPricesComments = false;
    state.showPricesPrices = false;
    state.showPricesHours = false;
    state.showCalculator = !state.showCalculator;
  },

  [types.TOGGLE_COMMENTS](state, item) {
    state.showCalculator = false;
    state.showPricesPrices = false;
    state.showPricesHours = false;
    state.showPricesComments = !state.showPricesComments;
  },

  [types.TOGGLE_HOURS](state, item) {
    state.showCalculator = false;
    state.showPricesComments = false;
    state.showPricesHours = !state.showPricesHours;
  },

  [types.TOGGLE_PRICES](state, item) {
    state.showCalculator = false;
    state.showPricesComments = false;
    state.showPricesPrices = !state.showPricesPrices;
  },

  [types.LOGGED_IN](state, item) {
    state.uid = item.uid;
    state.emailVerified = item.emailVerified;
  },

  [types.AFTER_EMAIL_RECOVERY](state, item) {
    state.afterEmailRecovery = true;
  },
  [types.PROJECT_FROM_TOKEN](state, item) {
    state.tokenData = item;
  },

  [types.CLEAR_STATE] (state, item) {
    for (let one in DefaultState) {
      if (one !== 'redirectUrl') {
        state[one] = DefaultState[one]
      }
    }
    state.myProjectDetails = {}
    state.myProjectDetailsFull = {}
    state.myProjects = {}
  },

  [types.UPDATE_CURRENT_PROJECT](state, item) {
    if (item.contingency) {
      state.currentProjectContingency = item.contingency;
    }
    if (item.blendedRate) {
      state.currentProjectRate = item.blendedRate;
    }
    if (item.name) {
      state.currentProjectName = item.name;
    }
    if (item.currentProjectPhases) {
      state.currentProjectPhases = item.phases;
    }
    if (item.comments) {
      state.currentProjectComments = item.comments;
    } else if (!item.dontNull) {
      state.currentProjectComments = {};
    }
  },

  [types.CHANGE_PRICE_RANGE](state, item) {
    state.selectedPriceRange = item.selectedPriceRange;
  },

  [types.UPDATE_PROJECT_DETAILS](state, item) {
    state.myProjectDetails[item.projectid].name = item.name;
  },

  [types.LOAD_PROJECT_PART_DETAILS](state, item) {
    state.currentProjectName = item.name;
  },

  [types.UPDATE_PROJECT_FULL_DETAILS](state, item) {
    state.myProjectDetailsFull[item.projectid]['modules'][item.key3]['components'][item.key2]['moduleColumns'][item.component][item.key][item.pricingLevel] = parseFloat(item.value)
  },

  [types.UPDATE_CURRENT_PROJECT_MODULES](state, item) {
    state.currentProjectModules[item.key3]['components'][item.key2]['moduleColumns'][item.component][item.key][item.pricingLevel] = parseFloat(item.value)
  },

  [types.LOAD_PROJECT_FULL_DETAILS](state, item) {
    state.currentProjectOverrides = item.overrides || [];
    state.currentProjectModules = item.modules;
    state.currentProjectModuleColumns = item.moduleColumns;
    state.currentProjectContingency = item.contingency;
    state.currentProjectRate = item.blendedRate;
    state.currentProjectPhases = item.phases || [];
    state.currentProjectComments = item.comments || [];
    state.currentProjectFull = item
  },
  ["SET_LOGGED_IN"](state, item) {
    state.loggedIn = item;
  },
  ["SET_LOGGED_IN_LOADING"](state, item) {
    state.loggedInLoading = item;
  },
  [types.SAVE_USER_DATA](state, item) {
    state.email = item.email;
    state.fullName = item.fullName;
    item.emailVerified
      ? (state.emailVerified = item.emailVerified)
      : (state.emailVerified = false);
    // item.emailVerified ? state.emailVerified = item.emailVerified : false
    item.verificationKey
      ? (state.verificationKey = item.verificationKey)
      : null;
    state.company = item.company;
    state.phone = item.phone;
    state.address = item.address;
    state.city = item.city;
    state.country = item.country;
    state.province = item.province;
    state.postalCode = item.postalCode;
    state.loading = false;
    if (item.myProjects) {
      state.myProjects = item.myProjects;
    } else {
      state.myProjects = {};
    }
    if (item.myCompany) {
      state.myCompany = item.myCompany;
    }
    if (item.profileImage) {
      state.profileImage = item.profileImage;
    }
    if (item.billingID) {
      state.billingID = item.billingID;
    }
  },

  [types.SAVE_COMPANY_DATA](state, item) {
    state.companyName = item.name;
    state.companyPlan = item.plan;
    state.companyWebsite = item.website;
    state.companyType = item.type;
    state.companyRate = item.rate;
    state.companyContingency = item.contingency;
    state.companyCost = item.cost;
    state.projectTemplates = item.projectTemplates || [];
    // if (item.companyTasks) {
    state.companyTasks = item.companyTasks;
    // }
    if (item.image) {
      state.companyImage = item.image;
    }

    if (item.phone) {
      state.companyPhone = item.phone;
    }
    if (item.address) {
      state.companyAddress = item.address;
    }
    if (item.city) {
      state.companyCity = item.city;
    }
    if (item.country) {
      state.companyCountry = item.country;
    }
    if (item.province) {
      state.companyProvince = item.province;
    }
    if (item.postalCode) {
      state.companyPostalCode = item.postalCode;
    }
  },

  [types.ADD_PROJECT](state, item) {
    state.myProjectDetails[item.projectID] = item;
  },

  [types.ADD_PROJECT_LIST] (state, item) {
    state.myProjectDetails = {
      ...state.myProjectDetails,
      ...item
    }
  },

  [types.ADD_PROJECT_FULL](state, item) {
    state.myProjectDetailsFull[item.projectID] = item;
  },

  [types.ADD_PROJECT_FULL_LIST] (state, item) {
    state.myProjectDetailsFull = {
      ...state.myProjectDetailsFull,
      ...item
    }
  },

  [types.REMOVE_PROJECT](state, item) {
    const myProjectDetails = Object.assign({}, state.myProjectDetails)
    const myProject = Object.assign({}, state.myProjects)
    delete myProjectDetails[item]
    delete myProject[item]
    state.myProjectDetails = myProjectDetails
    state.myProjects = myProject
  },

  [types.SAVE_NEWS](state, item) {
    state.newsArticles = item;
  },

  [types.SAVE_PROFILE_IMAGE](state, item) {
    state.profileImage = item.url;
  },

  [types.SAVE_PROJECT_IMAGE](state, item) {
    state.myProjectDetails[item.projectID].image = item.url;
  },

  [types.SAVE_COMPANY_IMAGE](state, item) {
    state.companyImage = item.image;
  },

  [types.VERIFY_EMAIL](state, item) {
    state.emailVerified = true;
  },

  [types.ADD_USER](state, item) {
    state.employees.push(item);
  },

  [types.EDIT_USER](state, item) {
    for (let i = 0; i < state.employees.length; i++) {
      // eslint-disable-next-line
      if (state.employees[i].id == item.id) {
        state.employees[i] = Object.assign({}, state.employees[i], item);
      }
    }
  },

  [types.UPDATE_PROJECT_STATUS] (state, item) {
    state.myProjectDetails[item.projectid]['status'] = item.status;
  },

  [types.UPDATE_SELETED_CELL](state, item) {
    state.selectedCell = item;
  },
  [types.UPDATE_EDITING_CELL](state, item) {
    state.editingCell = item;
  },
  [types.UPDATE_BACKUP_POSITION](state, item) {
    state.backupPosition = item;
  },
  [types.UPDATE_UNDO_COUNT](state, item) {
    state.undoCount = item;
  },
  [types.UPDATE_FROM_UNDO](state, item) {
    state.fromUndo = item;
  },
  [types.UPDATE_PROJECT_BACKUP](state, item) {
    state.projectBackup = item;
  },
  [types.SET_USER_ROLE](state, item) {
    state.userRole = item;
  },
  [types.LOADING](state, item) {
    state.isLoading = item;
  },
  [types.SET_REDIRECT_URL](state, item) {
    state.redirectUrl = item;
  }
};
